import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {deploymentAccountGroupsKeys} from '../hooks/useDeploymentAccountGroupsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: deploymentAccountGroupsKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
